import { store } from "@/store";
import { getDeepProperty as getDeepObjectProperty } from "@/utils/object";



const preservatives = [
	"t"
]


export const preserveQuery = async (to:any, from:any, next:any) => {

	console.log("Mooo");
	if(to.name === from.name){
		return next();
	}
	
	let modified = false;
	preservatives.forEach(qk => {
		if(from.query[qk] !== undefined && to.query[qk] === undefined){
			to.query[qk] = from.query[qk];
			console.log(qk);
			modified = true;
		}
	})

	console.log(to);

	if(modified){
		console.log("MOD");
		return next({ query:to.query, replace:true})
	}
	
	


	next();
};